import { UserAgent, Registerer, Inviter, SessionState } from 'sip.js';

// Variables persistantes pour stocker les instances SIP
let userAgent = null;
let currentSession = null;

// Configuration standard pour le média et le serveur STUN (indispensable pour le son)
const inviteOptions = {
    sessionDescriptionHandlerOptions: {
        constraints: { audio: true, video: false },
        peerConnectionConfiguration: {
            iceServers: [{ urls: "stun:://google.com" }]
        }
    }
};

/**
 * Gère les événements d'une session (Appel Sortant ou Entrant)
 * C'est ici que l'on branche le flux audio sur le navigateur
 */
export const handleSessionEvents = (session) => {
        
    session.delegate = {
        onSessionDescriptionHandlerCreated: (sdh) => {
            sdh.peerConnection.ontrack = (event) => {
                console.log("AUDIO : Flux reçu !", event);
                const remoteAudio = document.getElementById('remoteAudio');
                
                if (remoteAudio) {
                    // Utilise le stream de l'event s'il existe, sinon crée-en un avec la track
                    if (event.streams && event.streams[0]) {
                        remoteAudio.srcObject = event.streams[0];
                    } else {
                        remoteAudio.srcObject = new MediaStream([event.track]);
                    }
                    
                    remoteAudio.play().catch(e => console.error("Erreur Play:", e));
                }
            };
        }
    };
    session.stateChange.addListener((newState) => {
        console.log(`État de la session : ${newState}`);
        switch (newState) {
            case SessionState.Established:
                console.log("Appel établi - Communication en cours");
                break;
            case SessionState.Terminated:
                console.log("Appel terminé - Nettoyage");
                const audio = document.getElementById('remoteAudio');
                if (audio) audio.srcObject = null;
                currentSession = null;
                break;
        }
    });
};

/**
 * Initialise la connexion WebSocket et l'enregistrement auprès de FreePBX
 */
export async function initialisesiptel() {
    console.log("Démarrage de l'UserAgent SIP...");


userAgent = new UserAgent({
    uri: UserAgent.makeURI(`sip:0978494650@phone.mutuello.com`),
    transportOptions: { server: "wss://phone.mutuello.com:8089/ws" },
    authorizationUsername: "0978494650",
    authorizationPassword: "$$secret$$",
    
    // --- CES LIGNES SONT CRUCIALES POUR SUPPRIMER LE ANONYMOUS ---
    contactName: "0978494650",
    displayName: "0978494650",
    contactParams: { transport: "ws" },
    // Force SIP.js à utiliser l'URI de l'UA pour le header From
    userAgentString: "SIP.js", 
});

    try {
        await userAgent.start();
        const registerer = new Registerer(userAgent);
        await registerer.register();
        console.log("Téléphone enregistré et prêt");
    } catch (error) {
        console.error("Échec de l'initialisation SIP:", error);
    }
}

/**
 * Lance un appel vers un numéro  0978450642  ou *43
 */

export function phonesip(number) {
    if (!userAgent) return;

    // NETTOYAGE : sip:0978494650@phone.mutuello.com
    const target = UserAgent.makeURI(`sip:0978450642@phone.mutuello.com`);
    
    const inviteOptions = {
        // CORRECTION : On utilise des URIs propres ici aussi
        params: {
            fromDisplayName: "0978494650",
            fromUri: "sip:0978494650@phone.mutuello.com"
        },
        sessionDescriptionHandlerOptions: {
            constraints: { audio: true, video: false },
            peerConnectionConfiguration: {
                iceServers: [{ urls: "stun:://google.com" }]
            }
        }
    };

    currentSession = new Inviter(userAgent, target, inviteOptions);
    handleSessionEvents(currentSession);
    currentSession.invite();
}


/**
 * Décroche un appel entrant
 */
export function deccrocher() {
    if (currentSession && currentSession.state === SessionState.Initial) {
        console.log("Décrochage de l'appel...");
        currentSession.accept(inviteOptions);
    }
}

/**
 * Raccroche l'appel en cours (sortant, entrant ou en sonnerie)
 */
export function raccrocher_siptel() {
    if (!currentSession) return;

    if (currentSession.state === SessionState.Established) {
        currentSession.bye();
    } else {
        currentSession.cancel();
    }
    console.log("Demande de fin d'appel envoyée");
}
